var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhlc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PHLC"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "53.28 54.53 53.28 106.82 32.25 106.82 32.25 23.18 53.28 23.18 53.28 45.64"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 64.75,
    cy: 32.74,
    rx: 6.69,
    ry: 7.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "76.22 45.64 76.22 23.18 97.25 23.18 97.25 106.82 76.22 106.82 76.22 54.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.22 103 76.22 54.6 94.38 45.64 35.12 45.64 53.28 54.53 53.28 101.08 64.75 70.5 76.22 103"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhlc);
export default __webpack_public_path__ + "static/media/phlc.8154165ceee4a8f344991036559a4fe5.svg";
export { ForwardRef as ReactComponent };